module.exports = __webpack_public_path__ + "static/media/AB_W6_4.56d92846.jpg";